module.exports = "folder-open"